class RecentlyViewedProducts extends HTMLElement {
  static STORAGE_KEY = 'sasa:recently-viewed';

  connectedCallback() {
    const currentId = this.dataset.currentProductId;
    const currentHandle = this.dataset.currentProductHandle;

    if (currentId && currentHandle) {
      this.trackView(currentId, currentHandle);
    }

    this.loadProducts();
  }

  trackView(id, handle) {
    try {
      let items = JSON.parse(localStorage.getItem(RecentlyViewedProducts.STORAGE_KEY) || '[]');
      items = items.filter((item) => String(item.id) !== String(id));
      items.unshift({ id: String(id), handle });
      localStorage.setItem(RecentlyViewedProducts.STORAGE_KEY, JSON.stringify(items.slice(0, 20)));
    } catch (error) {
      console.error(error);
    }
  }

  async loadProducts() {
    const grid = this.querySelector('[data-recently-viewed-grid]');
    const wrapper = this.closest('.shopify-section');
    const currentId = this.dataset.currentProductId;
    const limit = Number.parseInt(this.dataset.limit || '4', 10);
    const cardSection = this.dataset.cardSectionId || 'recently-viewed-card';

    if (!grid) return;

    let items = [];
    try {
      items = JSON.parse(localStorage.getItem(RecentlyViewedProducts.STORAGE_KEY) || '[]');
    } catch (error) {
      console.error(error);
    }

    items = items.filter((item) => item.handle && String(item.id) !== String(currentId)).slice(0, limit);

    if (!items.length) {
      wrapper?.classList.add('hidden');
      return;
    }

    for (const item of items) {
      try {
        const response = await fetch(`${window.Shopify.routes.root}products/${item.handle}?sections=${cardSection}`);
        if (!response.ok) continue;

        const json = await response.json();
        const html = json[cardSection];
        if (!html) continue;

        const temp = document.createElement('div');
        temp.innerHTML = html;
        const card = temp.querySelector('.grid__item');
        if (card) grid.appendChild(card);
      } catch (error) {
        console.error(error);
      }
    }

    if (!grid.children.length) {
      wrapper?.classList.add('hidden');
    } else {
      wrapper?.classList.remove('hidden');
      this.classList.add('recently-viewed--loaded');
    }
  }
}

if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
